var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"sunrise","appear":""}},[_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }